import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    timeZone: null, // Default value, can be set to 'UTC' if you prefer
};

const timeZoneSlice = createSlice({
    name: 'timeZone',
    initialState,
    reducers: {
        setTimeZone(state, action) {
            state.timeZone = action.payload;
        },
    },
});

export const { setTimeZone } = timeZoneSlice.actions;

export default timeZoneSlice.reducer;
